import React from 'react';
import { Link, Navigate, useLocation, useSearchParams } from 'react-router-dom';

import { Card } from '@copilot/ui';
import ContactForm from '../components/contact/ContactForm';
import Loader from '../components/common/Loader';
import { useAuth } from '../hooks/useAuth';

// PUBLIC route (/contact).
//
// For a visitor, Contact Us is a section of the landing page, not a page
// of its own - so /contact (and /contact?reason=custom-plan, which the
// pricing "Custom" card links to) sends them to that section, keeping
// the query.
//
// A signed-in user never sees the landing page (it redirects into the
// app), so the same form is shown here instead: someone already on a
// plan is exactly who asks for a Custom one.
function ContactPage() {
  const { user, isLoading } = useAuth();
  const { search } = useLocation();
  const [searchParams] = useSearchParams();

  if (isLoading) return <Loader label="Loading..." />;
  if (!user) return <Navigate to={`/${search}#contact`} replace />;

  return (
    <div className="auth-page">
      <div className="auth-card contact-card">
        <div className="auth-brand">
          <Link className="auth-brand-title" to="/">KrishvaQ</Link>
          <div className="auth-brand-subtitle">AI Meeting Assistant</div>
        </div>

        <Card>
          <h1 className="auth-heading">Contact Us</h1>
          <p className="auth-panel-subtitle">
            Have a question or need a plan that fits your needs? Send us a
            message and we&apos;ll get back to you.
          </p>

          <ContactForm reason={searchParams.get('reason')} />
        </Card>

        <div className="auth-footer-link">
          <Link to="/">Back to KrishvaQ</Link>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
